export function roundTabCoordinates(coords) {
    return Math.round(coords * 10) / 10;
}
